<div class="modal-header">
  <h4 class="modal-title pull-left">Assign Analyst</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <crm-alert #alert></crm-alert>
  <div class="row">
    <div class="col-sm-12">
      <label class="rbv-label">Assign To</label>
      <input-search [position]="ReportUserType.FINANCIAL_ANALYST" [provider]="userProvider" 
        [inputValue]="selectedAssignee" placeholder="Select User to Assign" [itemsHeader]="'Search Results'"
        (valueChange)="assignToSelected($event)"></input-search>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" (click)="onConfirm()">Confirm</button>
</div>
